export function getAdressDetailsFromAddressString(addressString: string) {
  if (!addressString) return { city: '', state: '', zip: '', line1: '' };

  const [line1 = '', city = '', stateAndZip = ''] = addressString.split(', ');

  const [state = '', zip = ''] = stateAndZip.split(' ');

  return { city, state, zip, line1 };
}
